// extracted by mini-css-extract-plugin
export default {"icon-text":"styles__icon-text____uDBC","button":"styles__button___Sga0Z"};